import DatePicker from '../date-picker/DatePicker';
import { ViewMode } from '../date-picker/enum';
export default class YearPicker extends DatePicker {
    getWrapperClassNames() {
        const { prefixCls } = this;
        return super.getWrapperClassNames(`${prefixCls}-year-picker-wrapper`);
    }
}
YearPicker.displayName = 'YearPicker';
YearPicker.defaultProps = {
    ...DatePicker.defaultProps,
    mode: ViewMode.year,
};
